export const NAVBUTTON_CLICK = 'NAVBUTTON_CLICK';
export const SUBMENUBUTTON_CLICK = 'SUBMENUBUTTON_CLICK';
export const LINK_CLICK = 'LINK_CLICK';
export const PALETTE_SET_OPEN = 'PALETTE_SET_OPEN';
